import React from "react";
import SafeZapApp from "./modules/app/SafeZapApp";
import ErrorBoundary from "./components/ErrorBoundary";

export default function App() {
  return (
    <ErrorBoundary>
      <SafeZapApp />
    </ErrorBoundary>
  );
}
